import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
  [ModulesConfigMap[ModulesMap.DONE_WORKS_MY_WORKS_TO_CONTROL].GET_MY_WORKS_TO_CONTROL]:{
    url:'/company/:companyId/done_works/my_works/to_control/'
  }
}